import { useData } from 'vike-react/useData';
import type { PageData } from './+data';
import { ChartDisplayPage } from '~/components/ChartDisplayPage';

export function Page() {
  const { chartInfo, chartData, versions }: PageData = useData();

  return <ChartDisplayPage chartInfo={chartInfo} chartData={chartData} versions={versions} />;
}
